import { theme } from './theme';

// Common animation variants to be reused across components
export const commonVariants = {
  // Page/Container animations
  containerVariants: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: theme.animations.medium,
        staggerChildren: 0, // No stagger - text and images appear simultaneously
      },
    },
  },

  // Item animations (for lists, cards, etc.)
  itemVariants: {
    hidden: { 
      opacity: 0, 
      y: theme.animations.moveMedium 
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: theme.animations.medium,
        ease: 'easeOut',
      },
    },
  },

  // Image animations
  imageVariants: {
    hidden: { 
      opacity: 0, 
      scale: theme.animations.scaleSmall 
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: theme.animations.slow,
        ease: 'easeOut',
      },
    },
  },

  // Modal animations
  modalVariants: {
    hidden: { 
      opacity: 0, 
      scale: theme.animations.scaleMedium 
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: theme.animations.fast,
        ease: 'easeOut',
      },
    },
    exit: {
      opacity: 0,
      scale: theme.animations.scaleMedium,
      transition: {
        duration: theme.animations.fast,
      },
    },
  },

  // Overlay animations (for modals, dropdowns)
  overlayVariants: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: theme.animations.fast,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: theme.animations.fast,
      },
    },
  },

  // Text animations (for headlines, paragraphs)
  textVariants: {
    hidden: { 
      opacity: 0, 
      y: theme.animations.moveSmall 
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: theme.animations.medium,
        ease: 'easeOut',
      },
    },
  },

  // Button hover animations
  buttonHover: {
    scale: 1.02,
    transition: {
      duration: 0.2,
      ease: 'easeOut',
    },
  },

  buttonTap: {
    scale: 0.98,
    transition: {
      duration: 0.1,
      ease: 'easeOut',
    },
  },
};

// Stagger configurations for different use cases
export const staggerConfigs = {
  fast: {
    staggerChildren: theme.animations.staggerFast,
  },
  medium: {
    staggerChildren: theme.animations.staggerMedium,
  },
  slow: {
    staggerChildren: theme.animations.staggerSlow,
  },
};